import * as tslib_1 from "tslib";
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import Portal from '../portal/Portal';
import cn from 'astro-classname';
import '../notify/index.css';
var NotifyInner = (function (_super) {
    tslib_1.__extends(NotifyInner, _super);
    function NotifyInner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotifyInner.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, message = _b.message, selector = _b.selector, close = _b.close, position = _b.position, theme = _b.theme, prefix = _b.prefix, isIn = _b.isIn;
        var classes = cn(className, prefix + "-inner", (_a = {},
            _a[prefix + "-" + theme] = theme,
            _a));
        var styles = Object.assign({}, position);
        if (!position.left && !position.right) {
            styles.right = 30;
        }
        return (React.createElement(Portal, { selector: selector, style: styles },
            React.createElement(CSSTransition, { in: isIn, timeout: 500, classNames: "zhui-notify", onExited: function () { return close(); } },
                React.createElement("div", { className: classes },
                    React.createElement("span", null, message)))));
    };
    NotifyInner.defaultProps = {
        className: '',
        message: '',
        selector: '',
        theme: 'light',
        prefix: 'zhui-notify',
        position: {}
    };
    return NotifyInner;
}(React.Component));
export default NotifyInner;
